import React from 'react';
import Announcement from '../Announcement';

export default function DEIAnnouncement() {
    if (window && !window.location.href.includes('company/jobs/')) {
        return null;
    }
    return (
        <Announcement
            analyticsEvent='dei'
            href='/company/dei/'
            buttonText='Our Pledge'
            style={{backgroundColor: '#000000'}}
        >
            Black Lives Matter. We stand with the Black community and the
            movement to eradicate racism.
        </Announcement>
    );
}
